// import { ThemeProvider } from '@emotion/react';
// import customeTheme from './Theme/customeTheme';
// import { Button } from '@mui/material';
// import Navbar from './customer/components/Navbar/Navbar';
// import Home from './customer/pages/Home/Home';
// import Footer from './customer/components/Footer/Footer';
// import Products from './customer/pages/Products/Products';
// import { Route, Routes, useNavigate } from 'react-router-dom';
// import ScrollToTop from './routes/ScrollToTop';


// import SellerDashboard from './seller/pages/SellerDashboard/SellerDashboard';
// import CustomerRoutes from './routes/CustomerRoutes';
// import AdminDashboard from './admin/pages/Dashboard/Dashboard';
// import SellerAccountForm from './customer/pages/BecomeSeller/SellerAccountForm';
// import SellerAccountVerification from './seller/pages/SellerAccountVerification';
// import SellerAccountVerified from './seller/pages/SellerAccountVerified';
// import { useAppDispatch, useAppSelector } from './Redux Toolkit/Store';
// import { useEffect } from 'react';
// import { fetchSellerProfile } from './Redux Toolkit/Seller/sellerSlice';
// import BecomeSeller from './customer/pages/BecomeSeller/BecomeSeller';
// import AdminLoginForm from './admin/pages/Auth/AdminLogin';
// import AdminAuth from './admin/pages/Auth/AdminAuth';
// import { fetchUserProfile } from './Redux Toolkit/Customer/UserSlice';
// import { createHomeCategories, fetchHomePageData } from './Redux Toolkit/Customer/Customer/AsyncThunk';
// import { homeCategories } from './data/homeCategories';
// import Mobile from './data/Products/mobile';

// function App() {
//   const dispatch = useAppDispatch()
//   const { auth, sellerAuth, sellers, user } = useAppSelector(store => store)
//   const navigate = useNavigate();

//   useEffect(() => {
//     if (localStorage.getItem("jwt")) {
//       dispatch(fetchUserProfile({ jwt: localStorage.getItem("jwt") || auth.jwt || "", navigate }));
//       dispatch(fetchSellerProfile(localStorage.getItem("jwt") || sellerAuth.jwt))
//     }

//   }, [auth.jwt, sellerAuth.jwt])

//   useEffect(() => {
//     dispatch(createHomeCategories(homeCategories))
//     // dispatch(fetchHomePageData())
//   }, [dispatch])

//   //   return (
//   //     <ThemeProvider theme={customeTheme}>
//   //       <div className='App' >


//   //         <Routes>
//   //           {/* {sellers.profile && <Route path='/seller/*' element={<SellerDashboard />} />} */}
//   //           <Route path='/seller/*' element={<SellerDashboard />} />
//   //           {user.user?.role === "ROLE_ADMIN" && <Route path='/admin/*' element={<AdminDashboard />} />}
//   //           <Route path='/verify-seller/:otp' element={<SellerAccountVerification />} />
//   //           <Route path='/seller-account-verified' element={<SellerAccountVerified />} />
//   //           <Route path='/become-seller' element={<BecomeSeller />} />
//   //           <Route path='/admin-login' element={<AdminAuth />} />

//   //           <Route path='/dummy' element={<Mobile />} />

//   //           <Route path='*' element={<CustomerRoutes />} />

//   //         </Routes>
//   //         {/* <Footer/> */}
//   //       </div>



//   //     </ThemeProvider>
//   //   );
//   // }


//   return (
//     <ThemeProvider theme={customeTheme}>
//       <div className="App">
//         <ScrollToTop />

//         <Routes>
//           <Route path="/seller/*" element={<SellerDashboard />} />
//           {user.user?.role === "ROLE_ADMIN" && (
//             <Route path="/admin/*" element={<AdminDashboard />} />
//           )}
//           <Route path="/verify-seller/:otp" element={<SellerAccountVerification />} />
//           <Route path="/seller-account-verified" element={<SellerAccountVerified />} />
//           <Route path="/become-seller" element={<BecomeSeller />} />
//           <Route path="/admin-login" element={<AdminAuth />} />
//           <Route path="/dummy" element={<Mobile />} />
//           <Route path="*" element={<CustomerRoutes />} />
//         </Routes>
//       </div>
//     </ThemeProvider>
//   );
// }

// export default App;


// Reduce routiung logic

import React, { Suspense, lazy, useEffect } from "react";
import { ThemeProvider } from "@emotion/react";
import { CircularProgress, Box } from "@mui/material";
import { Route, Routes, useNavigate } from "react-router-dom";

import customeTheme from "./Theme/customeTheme";
import ScrollToTop from "./routes/ScrollToTop";

import SellerAccountVerification from "./seller/pages/SellerAccountVerification";
import SellerAccountVerified from "./seller/pages/SellerAccountVerified";
import BecomeSeller from "./customer/pages/BecomeSeller/BecomeSeller";
import AdminAuth from "./admin/pages/Auth/AdminAuth";

import { useAppDispatch, useAppSelector } from "./Redux Toolkit/Store";
import { fetchSellerProfile } from "./Redux Toolkit/Seller/sellerSlice";
import { fetchUserProfile } from "./Redux Toolkit/Customer/UserSlice";
import { createHomeCategories } from "./Redux Toolkit/Customer/Customer/AsyncThunk";
import { homeCategories } from "./data/homeCategories";

const SellerDashboard = lazy(
  () => import("./seller/pages/SellerDashboard/SellerDashboard")
);

const AdminDashboard = lazy(
  () => import("./admin/pages/Dashboard/Dashboard")
);

const CustomerRoutes = lazy(() => import("./routes/CustomerRoutes"));

const Mobile = lazy(() => import("./data/Products/mobile"));

const PageLoader = () => (
  <Box
    sx={{
      minHeight: "60vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    }}
  >
    <CircularProgress />
  </Box>
);

function App() {
  const dispatch = useAppDispatch();
  const { auth, sellerAuth, user } = useAppSelector((store) => store);
  const navigate = useNavigate();

  useEffect(() => {
    const jwt = localStorage.getItem("jwt") || auth.jwt || "";

    if (jwt) {
      dispatch(fetchUserProfile({ jwt, navigate }));
      dispatch(fetchSellerProfile(jwt || sellerAuth.jwt));
    }
  }, [dispatch, auth.jwt, sellerAuth.jwt, navigate]);

  useEffect(() => {
    dispatch(createHomeCategories(homeCategories));
  }, [dispatch]);

  return (
    <ThemeProvider theme={customeTheme}>
      <div className="App">
        <ScrollToTop />

        <Suspense fallback={<PageLoader />}>
          <Routes>
            <Route path="/seller/*" element={<SellerDashboard />} />

            {user.user?.role === "ROLE_ADMIN" && (
              <Route path="/admin/*" element={<AdminDashboard />} />
            )}

            <Route
              path="/verify-seller/:otp"
              element={<SellerAccountVerification />}
            />
            <Route
              path="/seller-account-verified"
              element={<SellerAccountVerified />}
            />
            <Route path="/become-seller" element={<BecomeSeller />} />
            <Route path="/admin-login" element={<AdminAuth />} />
            <Route path="/dummy" element={<Mobile />} />
            <Route path="*" element={<CustomerRoutes />} />
          </Routes>
        </Suspense>
      </div>
    </ThemeProvider>
  );
}

export default App;
